import React, { useEffect } from "react";
import Navigation from "./Navigation";
import Footer from "./Footer";

function Contact() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="sub-banner-section-outer">
        <Navigation />
        <section className="sub-banner-section">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center">
                <div className="sub-banner-text">
                  <h1 className="mb-lg-4 mb-3 text-white">Contact Us</h1>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <section className="about-service-section contact-page-support-section">
        <div className="container">
          <div className="row">
            <div className="col-xl-7 col-lg-6 col-md-6 col-sm-12 d-md-flex align-items-lg-start align-items-md-center">
              <div
                className="about-service-section-img-content position-relative wow bounceIn"
                data-wow-duration="2s"
              >
                <figure className="about-service-section-shape-img-2 mb-0 position-absolute">
                  <img
                    className="img-fluid"
                    src="assets/images/about-service-section-shape-img-2.png"
                    alt=""
                  />
                </figure>
                <figure className="about-service-section-main-img mb-0 position-relative">
                  <img
                    className="img-fluid w-75"
                    src="assets/images/contact-us.jpg"
                    alt=""
                  />
                </figure>
              </div>
            </div>
            <div className="col-xl-5 col-lg-6 col-md-6 col-sm-12 text-md-left text-center">
              <div className="about-service-section-text position-relative">
                <figure className="about-service-section-shape-img-1 mb-0 position-absolute">
                  <img
                    className="img-fluid"
                    src="assets/images/about-service-section-shape-img-1.png"
                    alt=""
                  />
                </figure>
                <h2 className="mb-lg-4 mb-md-3 mb-2">Get in Touch With Us</h2>
                <p>
                  Do you have any questions? Learn how RRS can give your
                  business a head start. Please give us a call, drop us an email
                  or fill out the contact form and we’ll get back to you.
                </p>
                <div className="contact-box hover-effect">
                  <div className="row">
                    <div className="col-md-3 col-12">
                      <figure className="mb-0 text-center">
                        <img
                          className="img-fluid"
                          src="assets/images/email-icon.png"
                          alt=""
                        />
                      </figure>
                    </div>
                    <div className="col-md-9 col-12">
                      <h4 className="font-weight-bold">Email:</h4>
                      <a
                        className="d-block text-decoration-none text-size-16"
                        href="mailto:sales@remoterestaurantsupport.com"
                      >
                        sales@remoterestaurantsupport.com
                      </a>
                      <a
                        className="d-block text-decoration-none text-size-16"
                        href="mailto:info@remoterestaurantsupport.com"
                      >
                        info@remoterestaurantsupport.com
                      </a>
                    </div>
                  </div>
                </div>
                <div className="contact-box hover-effect">
                  <div className="row">
                    <div className="col-md-3 col-12">
                      <figure className="mb-0 text-center">
                        <img
                          className="img-fluid"
                          src="/assets/images/phone-icon.png"
                          alt=""
                        />
                      </figure>
                    </div>
                    <div className="col-md-9 col-12">
                      <h4 className="font-weight-bold">Phone:</h4>
                      <a
                        className="d-block text-decoration-none text-size-16"
                        href="tel:+14012035794"
                      >
                        +1 401-203-5794
                      </a>
                      {/*<a className="d-block text-decoration-none text-size-16"*/}
                      {/*   href="tel:+23456789012">+234 56 789 012</a>*/}
                    </div>
                  </div>
                </div>
                <div className="contact-box hover-effect mb-0 hide d-none">
                  <div className="row">
                    <div className="col-md-3 col-12">
                      <figure className="mb-0 text-center">
                        <img
                          className="img-fluid"
                          src="assets/images/mail-icon.png"
                          alt=""
                        />
                      </figure>
                    </div>
                    <div className="col-md-9 col-12">
                      <h4 className="font-weight-bold"> Visit Us: :</h4>
                      <span className="d-block text-size-16">
                        Headquarters - 1275 Boardman, Canfield Rd, Suite B
                        Boardman OH, 44512 Pakistan 13J, Ali Zeb Main Road,
                        Block J Gulberg III, 2nd floor, Lahore Pakistan. Office
                        #101 and 102 first floor, Evacuee trust complex, Sir
                        Agha Khan Road, plot 04, F5/1, Islamabad Pakistan. Floor
                        8, 9, 10 & 11, Bahria Town Tower Tariq Road
                        Shahrah-e-Quaideen Karachi, Pakistan.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="customer-base-section about-page-customer-base-section contact-form-section my-5 hide d-none">
        <div class="container">
          <div class=" order-xl-1 order-lg-1 order-md-1 order-sm-2 order-2 text-md-left text-center">
            <div class="customer-base-section-text position-relative text-center">
              <h2 class="mb-lg-4 mb-md-3 mb-2">
                Want to begin a dialogue? Connect with us by submitting the form
                below.
              </h2>
              <p>
                Your email address will not be published. Required fields are
                marked *
              </p>
              <div class="contact-form">
                <form method="POST" action="contact-form.php">
                  <div className="row">
                    <div className="col-6">
                      {" "}
                      <div class="form-group">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="First Name:"
                          name="name"
                          id="name"
                        />
                      </div>
                    </div>
                    <div className="col-6">
                      {" "}
                      <div class="form-group">
                        <input
                          type="email"
                          class="form-control"
                          placeholder="Last Name:"
                          name="email"
                          id="email"
                        />
                      </div>
                    </div>
                    <div className="col-12">
                      {" "}
                      <div class="form-group">
                        <input
                          type="email"
                          class="form-control"
                          placeholder="Your Email:"
                          name="email"
                          id="email"
                        />
                      </div>
                    </div>
                    <div className="col-6">
                      {" "}
                      <div class="form-group">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Phone Number:"
                          name="name"
                          id="name"
                        />
                      </div>
                    </div>
                    <div className="col-6">
                      {" "}
                      <div class="form-group">
                        <input
                          type="email"
                          class="form-control"
                          placeholder="Company:"
                          name="email"
                          id="email"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <textarea
                      class="form-control textarea"
                      placeholder="Add Comment:"
                      rows="3"
                      name="comments"
                      id="comments"
                    ></textarea>
                  </div>
                  <div class="submitform-button">
                    <button
                      type="submit"
                      id="submit"
                      class="submitform-btn hover-effect d-block"
                    >
                      Send Message
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Contact;
